import { render, staticRenderFns } from "./ModalEditDatingPreference.vue?vue&type=template&id=0cccefd7&scoped=true"
import script from "./ModalEditDatingPreference.vue?vue&type=script&lang=js"
export * from "./ModalEditDatingPreference.vue?vue&type=script&lang=js"
import style0 from "./ModalEditDatingPreference.vue?vue&type=style&index=0&id=0cccefd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cccefd7",
  null
  
)

export default component.exports